import { logger } from "@jkast90/kast-common/diagnostics";
import { isDesktop } from "../desktop/desktop";

// The worker (src/service-worker.js) is a build artifact, so the dev server
// has none to register; one left from a preview there is removed, or dev
// would serve its cached files. The desktop app loads the UI from its own
// bundle and needs none. Registered once the page has loaded, so its
// precache doesn't compete with the player's core for the network.
// `updateViaCache: "none"` and deploy.sh's no-store make each navigation
// check for a new worker.
export function registerServiceWorker() {
  if (!("serviceWorker" in navigator) || isDesktop) return;
  if (!import.meta.env.PROD) {
    void navigator.serviceWorker
      .getRegistrations()
      .then((registrations) => registrations.forEach((registration) => void registration.unregister()))
      .catch(() => undefined);
    return;
  }
  const register = () =>
    navigator.serviceWorker
      .register("/service-worker.js", { updateViaCache: "none" })
      .catch((e: unknown) => logger.warn("Service worker registration failed:", e));
  if (document.readyState === "complete") void register();
  else window.addEventListener("load", () => void register(), { once: true });
}
